import React from 'react'
import PropTypes from 'prop-types'
import FormRenderer from '../../../common/FormRenderer/FormRenderer'

export default class NewConsultationForm extends React.Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.renderContent = this.renderContent.bind(this)
  }

  handleSubmit (data) {
    this.props.handleSubmit(data)
  }

  renderContent () {
    if (this.props.config) {
      return <FormRenderer
        dataKey={this.props.config.key}
        saveData={this.handleSubmit}
        title={this.props.config.title}
        extraFieldContent={this.props.config.extraFieldContent}
        fields={this.props.config.fields}
        extraFieldEnabled={this.props.config.isExtraFieldEnabled} />
    } else {
      return <div>Loading</div>
    }
  }

  render () {
    return <div>
      {this.renderContent()}
    </div>
  }
}

NewConsultationForm.propTypes = {
  config: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Age/ConsultationInsertionForm/ConsultationInsertionForm.js